<template>

<div class="slider">
    <img v-if="position >= (2/3)" src="@/assets/pic-test.jpg" alt="background">
    <img v-else-if="position >= (1/3)" src="@/assets/madares-bg/ali-ibn-musa.jpg" alt="background">
    <img v-else src="@/assets/madares-bg/sadr.jpg" alt="background">
</div>
<div class="diwider-tape">
    <div class="brown-tape"></div>
    <div class="gray-tape"></div>
    <div class="green-tape"></div>
</div>
<div class="about-mesh">
    <div class="video-box">
        <video width="1920" controls class="video-place">
            <source src="/motion.mp4" type="video/mp4" />
        </video>
    </div>
    <div class="comment">
        <h2>{{ t('home.glance.title') }}</h2>
        <p style="white-space: pre-line;">{{ t('home.glance.text') }}</p>
    </div>
</div>

<div class="news-box">
    <span class="title">{{ t('home.news') }}</span>
    <div class="news">
        <!-- <div class="news-top" v-if="lastNews.vin[0].id" @click="$router.push('/visit/' + lastNews.vin[0].id + '/' + lastNews.vin[0].main_headline.replaceAll(` `, `-`))">
            <div class="news-top-back">
                <h3>{{ lastNews.vin[0] ? lastNews.vin[0].kicker : "" }}</h3>
                <a :href="'/visit/' + lastNews.vin[0].id + '/' + lastNews.vin[0].main_headline.replaceAll(` `, `-`)">{{ lastNews.vin[0] ? lastNews.vin[0].main_headline : '' }}</a>
            </div>
            <img :src="lastNews.vin[0] ? VUE_APP_SERVER_ROOT + 'picture/' + lastNews.vin[0].pictures.main : ''" alt="">
        </div>
        <div class="news-post-1" v-for="(thisNew, index) in lastNews.non_vin" :key="index" @click="$router.push('/visit/' + thisNew.id + '/' + thisNew.main_headline.replaceAll(` `, `-`))">
            <img :src="VUE_APP_SERVER_ROOT + 'picture/' + thisNew.pictures.main" alt="">
            <h4>نوشته شده در {{ (new Date(thisNew.created_datetime)).toLocaleTimeString("fa-IR").split(':').slice(0,2).join(':') }} مورخ {{ (new Date(thisNew.created_datetime)).toLocaleDateString("fa-IR") }}</h4>
            <h3>{{ thisNew.kicker }}</h3>
            <h2>{{ thisNew.main_headline }}</h2>
        </div>
        <div class="news-top" v-if="lastNews.vin[1].id" @click="$router.push('/visit/' + lastNews.vin[1].id + '/' + lastNews.vin[1].main_headline.replaceAll(` `, `-`))">
            <div class="news-top-back">
                <h3>{{ lastNews.vin[1] ? lastNews.vin[1].kicker : "" }}</h3>
                <a :href="'/visit/' + lastNews.vin[1].id + '/' + lastNews.vin[1].main_headline.replaceAll(` `, `-`)">{{ lastNews.vin[1] ? lastNews.vin[1].main_headline : '' }}</a>
            </div>
            <img :src="lastNews.vin[0] ? VUE_APP_SERVER_ROOT + 'picture/' + lastNews.vin[1].pictures.main : ''" alt="">
        </div> -->
        <NewsCard v-if="lastNews.vin[0].id" type="top" :the-new="lastNews.vin[0]" />
        <NewsCard v-for="(thisNew, index) in lastNews.non_vin" :key="index" type="post-1" :the-new="thisNew" />
        <NewsCard v-if="lastNews.vin[1].id" type="top" :the-new="lastNews.vin[1]" />
    </div>
    <router-link class="more" :to="$route.params.locale ? `/${$route.params.locale}/news/public` : '/news/public'">{{ t('home.more') }}</router-link>
</div>

<div class="calendar-box">
    <div class="container">
        <div class="calendar-pic">
            <h2>{{ t('home.calendar.title') }}</h2>
            <img src="@/assets/lifestyle.png" alt=" ">
        </div>

        <!-- <div class="calendar-comment">
            <h2>تقویم برنامه‌های مشکات</h2>
            <p>
                حوزه علمیه مشکات، مجموعه‌ای از مدارس و حوزه‌های علمیه است که در راستای تحقق رهنمودهای مقام معظم رهبری و تحول
                در نظام حوزه‌های علمیه با هدف پرورش طلاب مهذب و کارآمد در حد اجتهاد به منظور تولید و توسعه علوم دینی.
                حوزه علمیه مشکات، مجموعه‌ای از مدارس و حوزه‌های علمیه است که در راستای تحقق رهنمودهای مقام معظم رهبری.
            </p>
        </div> -->
        <div class="calendar-list">
            <div class="list-item">
                <table class="myTable">
                    <tbody>
                        <tr v-for="(event, i) in (auth && auth.news.create ? [...events, newEvent] : events)" :key="i" :class="event.link ? ['clickable'] : []">
                            <td v-if="event.link && !editingEvents[i]">
                                <a :href="event.link">
                                    <h2>{{ event.name }}</h2>
                                    <p>{{ numberToText(event.date.day) }} {{ numberToMonth(event.date.month) }} {{ numberToPersian(event.date.year) }}</p>
                                </a>
                                <span>
                                    <button type="button" :title="t('edit')" v-if="auth ? auth.news.edit : false" @click="editingEvents[i]++" style="float: left; color: #fff;">✎</button>
                                    <button type="button" :title="t('delete')" v-if="auth ? auth.news.delete : false" @click="onDeleteEvent(event.id)" style="float: left; color: #fff; font-size: 130%;">&times;</button>
                                </span>
                            </td>
                            <td v-else>
                                <span>
                                    <h2 v-if="!editingEvents[i]">{{ event.name }}</h2>
                                    <h2 v-else>
                                        <input v-if="editingEvents[i] -2" type="text" dir="rtl" :placeholder="t(i != events.length ? 'home.calendar.text' : 'home.calendar.new')" v-model="event.name">
                                        <input v-else type="url" dir="ltr" placeholder="https://" v-model="event.link">
                                    </h2>
                                    <p v-if="!editingEvents[i]">
                                        {{ numberToText(event.date.day) }} {{ numberToMonth(event.date.month) }} {{ numberToPersian(event.date.year) }}
                                    </p>
                                    <p v-else>
                                        <input type="number" dir="ltr" :placeholder="today[2]" step="1" min="1" max="31" v-model="event.date.day">
                                        /
                                        <input type="number" dir="ltr" :placeholder="today[1]" step="1" min="1" max="12" v-model="event.date.month">
                                        /
                                        <input type="number" dir="ltr" :placeholder="today[0]" step="1" min="1300" max="1500" v-model="event.date.year">
                                    </p>
                                </span>
                                <span v-if="!editingEvents[i]">
                                    <button type="button" :title="t('edit')" v-if="auth ? auth.news.edit : false" @click="editingEvents[i]++" style="float: left; color: #fff;">✎</button>
                                    <button type="button" :title="t('delete')" v-if="auth ? auth.news.delete : false" @click="onDeleteEvent(event.id)" style="float: left; color: #fff; font-size: 130%;">&times;</button>
                                </span>
                                <span v-else>
                                    <button type="button" :title="t('create')" @click="(i != events.length ? onSubmitEditEvent : onSubmitNewEvent)({ content: event.name, date: { day: event.date.day, month: event.date.month, year: event.date.year }, link: event.link }, event.id)" style="float: left; color: #fff;">&check;</button>
                                    <button type="button" :title="t('link')" @click="editingEvents[i] = !(editingEvents[i] - 1) + 1" class="link_button" style="float: left; color: #fff;"> </button>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="bameshkatiha">
    <span class="title">{{ t('home.students') }}</span>
    <div class="meshkati">
        <!-- <div class="meshkati-post-1" v-for="(thisNew,i) in lastStudentNews" :key="i" @click="$router.push(`/visit/${thisNew.id}/${thisNew.main_headline.replaceAll(` `, `-`)}`)">
            <img :src="VUE_APP_SERVER_ROOT + 'picture/' + thisNew.pictures.main" alt="">
            <h4>نوشته شده در {{ (new Date(thisNew.created_datetime)).toLocaleTimeString("fa-IR").split(':').slice(0,2).join(':') }} مورخ {{ (new Date(thisNew.created_datetime)).toLocaleDateString("fa-IR") }}</h4>
            <h3>{{ thisNew.kicker }}</h3>
            <h2>{{ thisNew.main_headline }}</h2>
        </div> -->
        <NewsCard v-for="(thisNew, i) in lastStudentNews" :key="i" type="post-1" meshkati :the-new="thisNew" />
    </div>
    <router-link :to="$route.params.locale ? `/${$route.params.locale}/news/students` : '/news/students'" class="more">{{ t('home.more') }}</router-link>
</div>

<div class="amo-pjo">
    <span class="title-white">{{ t('home.edu') }}</span>
    <div class="am-pj">
        <!-- <div class="am-pj-post" v-for="(thisNew,i) in lastEduNews" :key="i" @click="$router.push(`/visit/${thisNew.id}/${thisNew.main_headline.replaceAll(` `, `-`)}`)">
            <img :src="VUE_APP_SERVER_ROOT + 'picture/' + thisNew.pictures.main" alt="">
            <h3>{{ thisNew.kicker }}</h3>
            <h2>{{ thisNew.main_headline }}</h2>
        </div> -->
        <NewsCard v-for="(thisNew, i) in lastEduNews" :key="i" type="am-pj" :the-new="thisNew" />
    </div>
    <router-link :to="`${$route.params.locale ? `/${$route.params.locale}` : ''}/news/edu`" class="more-green">{{ t('home.more') }}</router-link>
</div>

<div class="mesh-masajed">
    <div class="about-masajed">
        <div class="about-mas">
            <h2>{{ t('home.schools.title') }}</h2>
            <p>{{ t('home.schools.text') }}</p>
        </div>
        <div class="masajed">
            <router-link class="masjed-01" v-for="(madrese,i) in madares" :key="i" :to="`${$route.params.locale ? `/${$route.params.locale}` : ''}/${madrese.en}`">
                <!-- <router-link class="masjed-01" v-for="(madrese,i) in madares" :key="i" :to="`${$route.params.locale ? `/${$route.params.locale}` : ''}/${madrese.center ? `centers/${madrese.en}` : `schools/${madrese.women ? `women/` : ''}${madrese.en}`}`"> -->
                <img v-if="i == 0" src="@/assets/madares/0.jpg" :alt="madrese.name">
                <img v-if="i == 1" src="@/assets/madares/1.jpg" :alt="madrese.name">
                <img v-if="i == 2" src="@/assets/madares/2.jpg" :alt="madrese.name">
                <img v-if="i == 3" src="@/assets/madares/3.jpg" :alt="madrese.name">
                <img v-if="i == 4" src="@/assets/madares/4.jpg" :alt="madrese.name">
                <img v-if="i == 5" src="@/assets/madares/5.jpg" :alt="madrese.name">
                <img v-if="i == 6" src="@/assets/madares/6.jpg" :alt="madrese.name">
                <img v-if="i == 7" src="@/assets/madares/7.jpg" :alt="madrese.name">
                <img v-if="i == 8" src="@/assets/madares/8.jpg" :alt="madrese.name">
                <img v-if="i == 9" src="@/assets/madares/9.jpg" :alt="madrese.name">
                <span>{{ madrese.name }}</span>
            </router-link>
        </div>
    </div>
</div>

<div class="info">
    <h2>{{ t('home.statistics.title') }}</h2>

    <div class="infos">
        <div class="info-1" v-for="(item, i) in [1,2,3,4]" :key="i">
            <img v-if="0 == i" src="@/assets/icon-2.png" alt="">
            <img v-else-if="1 == i" src="@/assets/icon-3.png" alt="">
            <img v-else-if="2 == i" src="@/assets/icon-1.png" alt="">
            <img v-else-if="3 == i" src="@/assets/icon-4.png" alt="">
            <span v-if="!statisticsEdit[i]" style="font-family: B Lotus, Doran, sans-serif; font-size: 160%;">{{ statistics[i] }}</span>
            <input type="number" v-model="statistics[i]" v-if="auth ? auth.news.edit : false" v-show="statisticsEdit[i]" style="font-family: B Lotus, Doran, sans-serif; background: none; border: none; border-bottom: 2px solid #0002; color: #8a5f2e; outline: none!important; width: 80px; font-size: 140%; text-align: center">
            <h3>
                {{ [t('home.statistics.schools'), t('home.statistics.students'), t('home.statistics.highEdu'), t('home.statistics.women')][i] }}
                <button type="button" v-if="auth ? auth.news.edit : false" v-show="!statisticsEdit[i]" class="edit" :title="t('edit')" @click="statisticsEdit[i] = !statisticsEdit[i]" style="border: none; background: transparent; cursor: pointer; margin: auto 3px; color: #970;">
                    &#x270E;
                </button>
                <button type="button" v-if="auth ? auth.news.edit : false" class="submit" :title="t('create')" v-show="statisticsEdit[i]" @click="submitEditStatistic(item,statistics[i])" style="border: none; background: transparent; cursor: pointer; margin: auto 3px; color: #209f89;">
                    &#x2714;
                </button>

            </h3>
        </div>
    </div>
</div>

<div class="news-box">
    <span class="title">{{ t('home.international') }}</span>
    <div class="international-box">
        <div class="international">
            <!-- <div class="news-top" v-if="lastInternationalNews.vin[0].id" @click="$router.push(($route.params.locale ? `/${$route.params.locale}` : '') + '/visit/' + lastInternationalNews.vin[0].id + '/' + lastInternationalNews.vin[0].main_headline.replaceAll(` `, `-`))">
                <div class="news-top-back">
                    <h3>{{ lastInternationalNews.vin[0].kicker }}</h3>
                    <a :href="'/visit/' + lastInternationalNews.vin[0].id + '/' + lastInternationalNews.vin[0].main_headline.replaceAll(` `, `-`)">{{ lastInternationalNews.vin[0].main_headline }}</a>
                </div>
                <img :src="lastInternationalNews.vin[0] ? VUE_APP_SERVER_ROOT + 'picture/' + lastInternationalNews.vin[0].pictures.main : ''" alt="">
            </div> -->
            <NewsCard type="top" v-if="lastInternationalNews.vin[0].id" :the-new="lastInternationalNews.vin[0]" />
            <!-- <div class="news-post-1" v-for="(thisNew,i) in lastInternationalNews.non_vin.slice(0,4)" :key="i" @click="$router.push(($route.params.locale ? `/${$route.params.locale}` : '') + '/visit/' + thisNew.id + '/' + thisNew.main_headline.replaceAll(` `, `-`))">
                <img :src="VUE_APP_SERVER_ROOT + 'picture/' + thisNew.pictures.main" alt="">
                <h4>{{ t('timeString', { time: (new Date(thisNew.created_datetime)).toLocaleTimeString(t('timeLocale')).match(/^..?:..?/g)[0], date: (new Date(thisNew.created_datetime)).toLocaleDateString(t('timeLocale')) }) }}</h4>
                <h3>{{ thisNew.kicker }}</h3>
                <a :href="'/visit/' + thisNew.id + '/' + thisNew.main_headline.replaceAll(` `, `-`)">{{ thisNew.main_headline }}</a>
            </div> -->
            <NewsCard type="post-1" v-for="(thisNew, i) in lastInternationalNews.non_vin.slice(0,4)" :key="i" :the-new="thisNew" />
        </div>
    </div>
    <router-link :to="`${$route.params.locale ? `/${$route.params.locale}` : ''}/news/international`" class="more">{{ t('home.more') }}</router-link>
</div>

</template>

<script setup>

import { useAuth } from '@/authentication'
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import NewsCard from '@/components/NewsCard'
import { useRoute } from 'vue-router'

const newsTemplate = { id: 0, main_headline: '', kicker: '', pictures: { main: null } }
    , lastNews = ref({ vin:[newsTemplate, newsTemplate], non_vin:[] })
    , lastInternationalNews = ref({ vin:[newsTemplate], non_vin:[] })
    , lastSchoolNews = ref([])
    , lastStudentNews = ref([])
    , lastEduNews = ref([])
    , VUE_APP_SERVER_ROOT = process.env.VUE_APP_SERVER_ROOT
    , newsFetched = ref(false)
    , isMounted = ref(false)
    , events = ref([])
    , editingEvents = ref([])
    , auth = useAuth()
    , $route = useRoute()
    , statistics = ref([0,0,0,0])
    , statisticsEdit = ref([false,false,false,false])
    , location = window.location
    , madares = [
        { name: 'مدرسه علی‌ابن‌موسی‌الرضا (علیهماالسلام)', en: 'ali-ibn-musa' },
        { name: 'مدرسه کریمه اهل‌بیت (سلام‌الله‌علیها)', en: 'karimeh' },
        { name: 'مدرسه صدر بازار', en: 'sadr' },
        { name: 'مدرسه امام جواد (علیه‌السلام)', en: 'imam-javad' },
        { name: 'مدرسه امام کاظم (علیه‌السلام)', en: 'imam-kazem' },
        { name: 'مدرسه امام صادق (علیه‌السلام)', en: 'imam-sadeq' },
        { name: 'مؤسسه آموزش عالی حوزوی - شعبه قم', en: 'markaz-qom', center: true },
        { name: 'مؤسسه آموزش عالی حوزوی - شعبه تهران', en: 'markaz-tehran', center: true },
        { name: 'مدرسه مشکات اندیشه خواهران تهران', en: 'women-tehran', women: true },
        { name: 'مدرسه مشکات اندیشه خواهران قم', en: 'women-qom', women: true },
    ],
    today = (new Date).toLocaleDateString('fa-ir').split('/').map(n => parseInt(persianNumToNum(n))),
    newEvent = ref({
        name: '',
        link: '',
        date: { day: '', month: '', year: '' },
        id: 0
    }),
    { t, locale } = useI18n(),
    position = ref(0)

onMounted(() => {
    position.value = Math.random()
})

if ($route.params.locale) locale.value = $route.params.locale

function dateTimeToDate(datetime) {
    return (new Date(datetime)).toLocaleDateString("fa-IR")
}

function numberToText(num) {
    var result = ""
    if (num > 31) return false;
    if ((num - num % 10) / 10 == 0) {
        switch (num % 10) {
            case 1: result = "یکم"; break;
            case 2: result = "دوم"; break;
            case 3: result = "سوم"; break;
            case 4: result = "چهارم"; break;
            case 5: result = "پنجم"; break;
            case 6: result = "ششم"; break;
            case 7: result = "هفتم"; break;
            case 8: result = "هشتم"; break;
            case 9: result = "نهم"; break;
        }
    } else if ((num - num % 10) / 10 == 1) {
        switch (num % 10) {
            case 0: result = "دهم"; break;
            case 1: result = "یازدهم"; break;
            case 2: result = "دوازدهم"; break;
            case 3: result = "سیزدهم"; break;
            case 4: result = "چهاردهم"; break;
            case 5: result = "پانزدهم"; break;
            case 6: result = "شانزدهم"; break;
            case 7: result = "هفدهم"; break;
            case 8: result = "هجدهم"; break;
            case 9: result = "نوزدهم"; break;
        }
    } else if ((num - num % 10) / 10 == 2 || (num - num % 10) / 10 == 3) {
        result = (num - num % 10) / 10 == 2 ? "بیست" : "سی"
        switch (num % 10) {
            case 0: result += (num - num % 10) / 10 == 2 ? "م" : "‌ام"; break;
            case 1: result += " و یکم"; break;
            case 2: result += " و دوم"; break;
            case 3: result += " و سوم"; break;
            case 4: result += " و چهارم"; break;
            case 5: result += " و پنجم"; break;
            case 6: result += " و ششم"; break;
            case 7: result += " و هفتم"; break;
            case 8: result += " و هشتم"; break;
            case 9: result += " و نهم"; break;
        }
    }
    return result
}
function numberToMonth(num) {
    var result = ""
    if (num > 12) return false

    switch (num) {
        case 1: var result = "فروردین"; break;
        case 2: var result = "اردیبهشت"; break;
        case 3: var result = "خرداد"; break;
        case 4: var result = "تیر"; break;
        case 5: var result = "مرداد"; break;
        case 6: var result = "شهریور"; break;
        case 7: var result = "مهر"; break;
        case 8: var result = "آبان"; break;
        case 9: var result = "آذر"; break;
        case 10: var result = "دی"; break;
        case 11: var result = "بهمن"; break;
        case 12: var result = "اسفند"; break;
    }

    return result
}
function persianNumToNum(num) {
    return parseInt(num
        .replaceAll('۰','0')
        .replaceAll('۱','1')
        .replaceAll('۲','2')
        .replaceAll('۳','3')
        .replaceAll('۴','4')
        .replaceAll('۵','5')
        .replaceAll('۶','6')
        .replaceAll('۷','7')
        .replaceAll('۸','8')
        .replaceAll('۹','9')
    )
}

function numberToPersian(num) {
    return num.toLocaleString('fa-ir').replaceAll('٬', "")
}

function onSubmitNewEvent(values) {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}new-event`,
        method: "POST",
        dataType: "json",
        xhrFields: {
            withCredentials: true
        },
        data: values,
        success(data) {
            if (data.STATUS) {
                alert('ثبت موفقیت آمیز بود')
                location.reload()
            } else {
                alert(data.REASON)
            }
        }
    })
}

function onSubmitEditEvent(values, id) {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}edit-event`,
        method: "POST",
        dataType: "json",
        xhrFields: {
            withCredentials: true
        },
        data: { ...values, id },
        success(data) {
            if (data.STATUS) {
                alert('ویرایش موفقیت آمیز بود')
                location.reload()
            } else {
                alert(data.REASON)
            }
        }
    })
}

function onDeleteEvent(id) {
    if(confirm('آیا مطمئنید می‌خواهید این رویداد را حذف کنید؟')) {
        $.ajax({
            url: `${process.env.VUE_APP_SERVER_ROOT}delete-event`,
            method: "POST",
            dataType: "json",
            xhrFields: { withCredentials: true },
            data: { id },
            success(data) {
                if (data.STATUS) {
                    alert('حذف موفقیت آمیز بود')
                    location.reload()
                } else {
                    alert(data.REASON)
                }
            }
        })
    }
}

function submitEditStatistic(id, value) {
    $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}statistics-edit`,
        method: "POST",
        dataType: "json",
        xhrFields: { withCredentials: true },
        data: { id, value },
        success(data) {
            if (data.STATUS) {
                alert('ویرایش موفقیت آمیز بود')
                location.reload()
            } else {
                alert(data.REASON)
            }
        }
    })
}

$.ajax({
    url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/last-news/8`,
    method: "GET",
    dataType: "json",
    xhrFields: { withCredentials: true },
    success(data) {
        if (data.STATUS) {
            lastNews.value = { vin: [data.VIN[0] ?? newsTemplate, data.VIN[1] ?? newsTemplate], non_vin: data.NON_VIN }
            newsFetched.value = true
        } else {
            alert("دریافت آخرین اخبار موفقیت آمیز نبود. لطفا با پشتیبانی تماس حاصل فرمایید")
        }
    },
    error() {
        alert("ارتباط با سرور ممکن نمی‌باشد")
    }
})
$.ajax({
    url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/last-news/5-international`,
    method: "GET",
    dataType: "json",
    xhrFields: { withCredentials: true },
    success(data) {
        if (data.STATUS) {
            lastInternationalNews.value = { vin: [data.VIN[0] ?? newsTemplate], non_vin: data.NON_VIN }
            newsFetched.value = true
        } else {
            alert("دریافت اخبار بین الملل موفقیت آمیز نبود. لطفا با پشتیبانی تماس حاصل فرمایید")
        }
    },
    error() {
        alert("ارتباط با سرور ممکن نمی‌باشد")
    }
})
$.ajax({
    url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/last-news/schools`,
    method: "GET",
    dataType: "json",
    xhrFields: { withCredentials: true },
    success(data) {
        if (data.STATUS) {
            lastSchoolNews.value = data.RESULT.map(n => n ?? newsTemplate)
            newsFetched.value = true
        } else {
            alert("دریافت اخبار مدارس موفقیت آمیز نبود. لطفا با پشتیبانی تماس حاصل فرمایید")
        }
    },
    error() {
        alert("ارتباط با سرور ممکن نمی‌باشد")
    }
})
$.ajax({
    url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/last-news/students`,
    method: "GET",
    dataType: "json",
    xhrFields: { withCredentials: true },
    success(data) {
        if (data.STATUS) {
            lastStudentNews.value = data.RESULT.map(n => n ?? newsTemplate)
            newsFetched.value = true
        } else {
            alert("دریافت اخبار طلاب موفقیت آمیز نبود. لطفا با پشتیبانی تماس حاصل فرمایید")
        }
    },
    error() {
        alert("ارتباط با سرور ممکن نمی‌باشد")
    }
})

$.ajax({
    url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/last-news/edu`,
    method: "GET",
    dataType: "json",
    xhrFields: { withCredentials: true },
    success(data) {
        if (data.STATUS) {
            lastEduNews.value = data.RESULT.map(n => n ?? newsTemplate)
            newsFetched.value = true
        } else {
            alert("دریافت اخبار آموزش و پژوهش موفقیت آمیز نبود. لطفا با پشتیبانی تماس حاصل فرمایید")
        }
    },
    error() {
        alert("ارتباط با سرور ممکن نمی‌باشد")
    }
})

$.ajax({
    url: `${process.env.VUE_APP_SERVER_ROOT}statistics`,
    method: "GET",
    dataType: "json",
    xhrFields: { withCredentials: true },
    success(data) {
        if (data.STATUS) {
            statistics.value = data.RESULT.map(n => n.value)
        } else {
            alert("دریافت آمار موفقیت آمیز نبود. لطفا با پشتیبانی تماس حاصل فرمایید")
        }
    },
    error() {
        alert("ارتباط با سرور ممکن نمی‌باشد")
    }
})

$.ajax({
    url: `${process.env.VUE_APP_SERVER_ROOT}${locale.value}/events`,
    method: "GET",
    dataType: "json",
    xhrFields: { withCredentials: true },
    success(data) {
        if (data.STATUS) {
            let result = data.RESULT.map((event,i) => {
                let date = event.date
                ,   enDate = (new Date(date)).toLocaleDateString("fa-ir")
                ,   [ year, month, day ] = enDate.split("/").map(n => parseInt(persianNumToNum(n)))

                event.date = { year, month, day }
                editingEvents.value[i] = 0
                return event
            })
            editingEvents.value.push(1)

            events.value = result
        } else {
            alert("دریافت رویدادها موفقیت آمیز نبود. لطفا با پشتیبانی تماس حاصل فرمایید")
        }
    },
    error() {
        alert("ارتباط با سرور ممکن نمی‌باشد")
    }
})

</script>